import { useContext } from 'react';
import { useRoutes } from '../hooks/useRoutes';
import { useTranslation } from 'react-i18next';
import AccountContext from '../contexts/AccountContext';
import FeatureTogglesContext from '../contexts/FeatureTogglesContext';
import { buildGroupProps } from '../utils/elementisUtils';

import Alert from '@pelckmans/elementis/components/alert';
import Button from '@pelckmans/elementis/components/button';

const BASE = 'SHARED_COMPONENTS.ONE_ROSTER_ADMIN_ALERT';

function OneRosterAdminAlert() {
  const {
    account: { smartschoolSchools },
  } = useContext(AccountContext);
  const { buildAbsolutePath } = useRoutes();
  const { t } = useTranslation();

  const { ONE_ROSTER_SYNC_BANNER } = useContext(FeatureTogglesContext);

  const adminSchool = smartschoolSchools.find(smsSchool => smsSchool.userIsAdmin);

  if (ONE_ROSTER_SYNC_BANNER && adminSchool) {
    if (!adminSchool.oneRoster?.enabled) {
      return (
        <Alert
          prominence="warning"
          actions={buildGroupProps(
            <Button
              as="link"
              href={buildAbsolutePath(['MY_PROFILE', 'MY_PROFILE.PERSONAL_DETAILS'])}
              prominence="warning"
            >
              {t(`${BASE}.ACTIONS.CONFIGURE`)}
            </Button>,
          )}
        >
          {t(`${BASE}.NO_SMARTSCHOOL_SYNC`)}
        </Alert>
      );
    }

    if (adminSchool.isSyncStale) {
      return <Alert prominence="warning">{t(`${BASE}.STALE_SMARTSCHOOL_SYNC`)}</Alert>;
    }
  }

  return null;
}

export default OneRosterAdminAlert;
